import styled from "styled-components";

export const Container = styled.div`
    padding-top: 30px;

    h1 {
        margin-bottom: 0;
    }
`
